import { APP_START_URL } from "@/const/app";

/**
 * 文字列を分割する。String.splitと異なる点は、空文字列・null・undefindの場合は空配列を返すこと
 */
export function split(
  str: string | null | undefined,
  delimiter = ","
): string[] {
  if (!str) return [];
  return str.split(delimiter);
}

/**
 * テキストに含まれるリンクを<a>タグで囲む
 * ただし、アプリのallow-navigationの制限でhttps://www.google.comはリンクになるが遷移できないことに注意
 * iOSのWKWebViewでは、target="_blank"を使用した場合にallow-navigationで
 * 許可されたドメインのリンクが正しく開けない制限があるため、
 * アプリ内部のドメインへのリンクには target="_blank" を付与しないようにする
 */
export function linkifyText(text: string | null): string {
  if (!text) return "";
  const regex = /https?:\/\/[-_.!~*'()a-zA-Z0-9;/?:@&=+$,%#]+/g;
  return (
    text
      // サニタイズ
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      // リンク化
      .replace(regex, url => {
        return APP_START_URL !== undefined && url.startsWith(APP_START_URL)
          ? `<a href="${url}">${url}</a>`
          : `<a href="${url}" target="_blank">${url}</a>`;
      })
  );
}

/**
 * 文字列の前後の空白を削除する
 */
export function strip(str: string) {
  return str.replace(/^\s+|\s+$/g, "");
}
